import { useParams, generatePath } from 'react-router-dom';
import { useAppSelector } from '@store';
import { PermissionEnum, DeviceSessionSidepanel } from '@ui/src';

import useDeviceForm from '../hooks/use-device-form';

import ROUTES from '../../../../routes';

const IndividualCustomerDeviceItem = () => {
  const { activePermissions } = useAppSelector((state) => state.root);
  const { devices, deviceSessions, deviceSessionsPagination } = useAppSelector(
    (state) => state.individualCustomers.info.devices,
  );

  const { deviceId, customerId } = useParams();

  const {
    panelIsOpen,
    handleClose,
    isLoading,
    endSession,
    device,
    onLinkClick,
    isFetching,
    deviceSessionsIsLoading,
    getDeviceSessions,
  } = useDeviceForm({
    customerId,
    deviceId,
    devices,
  });

  return (
    <DeviceSessionSidepanel
      panelIsOpen={panelIsOpen}
      handleClose={handleClose}
      deleteSessionIsAvailable={activePermissions?.includes(
        PermissionEnum.CUSTOMERS_SESSIONS_DELETE_ACTION,
      )}
      isLoading={isLoading}
      onEndSession={() => {
        endSession({
          id: customerId as string,
          deviceId: deviceId as string,
        });
      }}
      device={device}
      itemId={customerId}
      deviceId={deviceId}
      onLinkClick={onLinkClick}
      deviceSessions={deviceSessions}
      activePermissions={activePermissions}
      isFetching={isFetching}
      deviceSessionsIsLoading={deviceSessionsIsLoading}
      deviceSessionsPagination={deviceSessionsPagination}
      auditLink={ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS_ITEM}
      getDeviceSessions={getDeviceSessions}
      sessionIsAvailable={activePermissions?.includes(
        PermissionEnum.CUSTOMERS_DEVICE_SESSIONS_LIST,
      )}
      backLink={generatePath(
        ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES_ITEM,
        { customerId: customerId as string, deviceId: deviceId as string },
      )}
      customerDevices
    />
  );
};

export default IndividualCustomerDeviceItem;
